import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import Typography from '@classify/react-core-components/Typography';
import { styled } from '@classify/react-core-components/styles';
const Content = styled('div')(({
  theme: {
    spacing,
    breakpoints,
    palette,
    typography
  }
}) => ({
  margin: spacing(2, 0, 2, 4),
  '& .sr-only': {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap',
    border: 0
  },
  position: 'relative',
  '& p, li': {
    ...typography.body1,
    color: palette.primary.main,
    margin: 0
  },
  '& li': {
    marginTop: spacing(2)
  },
  '&::before': {
    borderLeft: [2, 'solid', palette.primary.main],
    content: "' '",
    position: 'absolute',
    height: '2rem',
    left: '-1rem'
  },
  [breakpoints.up('md')]: {
    margin: 0,
    position: 'absolute',
    width: 232,
    marginLeft: spacing(66),
    '&::before': {
      display: 'none'
    }
  },
  [breakpoints.up('lg')]: {
    width: 268,
    marginLeft: spacing(75)
  }
}));
type ContentShortTextProps = {
  content: string;
};
export default function ContentShortText(t0) {
  const $ = _c(3);
  const {
    content
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="sr-only">{translate("policies.information_block.accessibility_text")}</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== content) {
    t2 = <Content>{t1}<Typography component="div" dangerouslySetInnerHTML={{
        __html: content
      }} /></Content>;
    $[1] = content;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}